(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hvc-offer-experiment"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = JSON.parse(document.getElementById('hvc-offer-config').textContent);
  if (window.Shopify?.designMode) return;
  const DAY = 86400000;
  const key = `hvc-offer:${config.experiment}:${config.qa ? 'qa' : 'live'}`;
  const forms = ['TLEus5', 'Y6g5q8'];
  let assignment, started = false, opening = false, shown = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const read = () => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
  const write = (value) => { localStorage.setItem(key, JSON.stringify(value)); };
  const publish = (name, extra = {}) => {
    if (!assignment || !allowed()) return;
    window.Shopify?.analytics?.publish(`hvc_offer:${name}`, {
      experiment: config.experiment, visitor_id: assignment.id, group: assignment.group,
      assigned_at: assignment.assignedAt, qa: config.qa, ...extra
    });
  };
  const identified = async () => {
    if (config.knownCustomer) return true;
    if (typeof window.klaviyo?.isIdentified !== 'function') return null;
    try {
      return await Promise.race([
        Promise.resolve(window.klaviyo.isIdentified()),
        new Promise(resolve => setTimeout(() => resolve(null), 3000))
      ]);
    } catch { return null; }
  };
  const open = async () => {
    if (opening || shown || !assignment || assignment.group !== 'offer' || !allowed()) return;
    const latest = read();
    if (!latest || latest.submitted || Date.now() - (latest.closedAt || 0) < 14 * DAY) return;
    if (document.querySelector('#wa-popup-overlay.wa-show, [role="dialog"][aria-modal="true"]')) return;
    opening = true;
    const known = await identified();
    if (known !== false || !allowed()) { opening = false; return; }
    const formId = matchMedia('(max-width: 767px)').matches ? forms[1] : forms[0];
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    shown = true;
    opening = false;
  };
  const start = async () => {
    if (started || !allowed() || !window.Shopify?.analytics?.publish) return;
    started = true;
    const existing = read();
    if (existing && typeof existing.id === 'string' && ['offer', 'control'].includes(existing.group)) {
      assignment = existing;
    } else {
      const known = await identified();
      if (known !== false || !allowed()) { started = false; return; }
      assignment = {
        id: crypto.randomUUID(),
        group: crypto.getRandomValues(new Uint32Array(1))[0] < 2147483648 ? 'offer' : 'control',
        assignedAt: new Date().toISOString()
      };
      try { write(assignment); } catch { assignment = null; return; }
    }
    if (!allowed()) { started = false; return; }
    publish('assignment');
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {
        'hvc_experiment__': config.experiment, 'hvc_visitor__': assignment.id,
        'hvc_group__': assignment.group, 'hvc_qa__': String(config.qa)
      }})
    }).catch(() => {});
    document.documentElement.addEventListener('mouseleave', e => {
      if (e.clientY <= 0 && !matchMedia('(max-width: 767px)').matches) open();
    });
    const began = Date.now();
    const mobileCheck = () => {
      const distance = document.documentElement.scrollHeight - innerHeight;
      if (matchMedia('(max-width: 767px)').matches && Date.now() - began >= 30000 && distance > 0 && scrollY / distance >= 0.3) open();
    };
    addEventListener('scroll', mobileCheck, {passive: true});
    setTimeout(mobileCheck, 30000);
    window.addEventListener('klaviyoForms', e => {
      if (!forms.includes(e.detail?.formId) || !allowed()) return;
      const type = e.detail.type;
      if (!['open', 'close', 'submit'].includes(type)) return;
      const state = read() || assignment;
      if (type === 'close') state.closedAt = Date.now();
      if (type === 'submit') state.submitted = true;
      try { write(state); } catch {}
      publish(type, {form_id: e.detail.formId});
    });
  };
  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) start();
  });
  const timer = setInterval(() => { start(); if (started) clearInterval(timer); }, 500);
  setTimeout(() => clearInterval(timer), 30000);
  start();
})();
  } catch(e) { console.error(e); }
})();

})();
